/**
 * Typed path builders. Links use these rather than string literals, so renaming a route
 * is a compile error instead of a dead link found in production.
 */
export const paths = {
  login: '/login',
  activate: '/activate-account',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  changePassword: '/change-password',
  sessions: '/settings/sessions',

  dashboard: '/dashboard',

  employees: '/employees',
  employeeNew: '/employees/new',
  employee: (id: string) => `/employees/${id}`,
  me: '/me',
  myTeam: '/my-team',

  organization: '/organization',
  departments: '/departments',

  /** Time & leave hub (attendance, leave, holidays, leave types). */
  time: '/time',
  attendance: '/time/attendance',
  teamAttendance: '/time/attendance/team',

  leave: '/time/leave',
  leaveDetail: (id: string) => `/time/leave/${id}`,
  teamLeave: '/time/leave/team',
  leaveTypes: '/time/leave-types',
  leaveApply: '/time/leave/apply',
  leaveCalendar: '/time/leave/calendar',

  tasks: '/tasks',
  taskBoard: '/tasks/board',

  workReports: '/work-reports',
  workReportNew: '/work-reports/new',

  approvals: '/approvals',

  announcements: '/announcements',
  notifications: '/notifications',
  notificationPreferences: '/notifications/preferences',
  notificationPolicy: '/settings/notification-policy',
  workSessions: '/work-sessions',

  documents: '/employees/documents',
  onboarding: '/employees/onboarding',
  holidays: '/time/holidays',

  reports: '/reports',

  settings: '/settings',
  companySettings: '/settings/company',
  roles: '/settings/roles',
  auditLogs: '/audit-logs',
  portalActivity: '/admin/portal-activity',
  systemHealth: '/system/health',
  support: '/support',
  supportMyRequests: '/support/my-requests',
  supportTechnical: '/support/technical',
  supportCompany: '/support/company',
  supportTicket: (id: string) => `/support/tickets/${id}`,
  supportAlertSettings: '/settings/support-alerts',

  offline: '/offline',
  designSystem: '/design-system',

  forbidden: '/403',
} as const;
